import React, { Component } from "react";
import { Radio, Col, ControlLabel, FormGroup, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { Control, Form } from "react-redux-form";
import ArrowButton from "../../../common/button-arrow";

class FeatureToggleForm extends Component {
  render() {
    const { model, description, onSubmit, formValid } = this.props;

    return(
      <div className="container-fluid">
        <Form model={model} onSubmit={onSubmit}>       
          <FormGroup controlId="featureTogglEnabled">
            <div>
              <ControlLabel>{description}</ControlLabel>
            </div>
            <Control.radio
              model=".enabled"
              value="true"
              component={Radio}
            >
              Enable
            </Control.radio>
            <Control.radio
              model=".enabled"
              value="false"
              component={Radio}   
            >
              Disable
            </Control.radio>
          </FormGroup>
          <Row>
            <Col md={2} mdOffset={10}>
              <ArrowButton
                className="pull-right"
                arrow={false}
                disabled={!formValid}
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  description: state.deep.forms.admin_feature_toggle_save.description.value,
  formValid: state.deep.forms.admin_feature_toggle_save.$form.valid
})

export default connect(mapStateToProps)(FeatureToggleForm);



// WEBPACK FOOTER //
// ./src/components/admin/feature-toggles/form/feature-toggle-form.jsx